import { call, put, takeLatest, select } from 'redux-saga/effects';

import { userApi } from '../../../api';

import * as actions from './actions';

import { selectSecret } from '../../router/selectors';

function* emailConfirmation() {
  try {
    yield put({ type: actions.CONFIRM_EMAIL_PENDING });
    const secret = yield select(selectSecret);
    const { status } = yield call(userApi.activate, { secret });

    if (status === 200) {
      yield put({ type: actions.CONFIRM_EMAIL_FULFILLED });
    }
  } catch (e) {
    yield put({ type: actions.CONFIRM_EMAIL_REJECTED, payload: e });
  }
}

export function* watchEmailConfirmation() {
  yield takeLatest(actions.CONFIRM_EMAIL, emailConfirmation);
}
